module.exports = __webpack_public_path__ + "img/Frage4_2048x1536.285b2da4.jpg";